import _ from "lodash";
import axios from "axios";
import { ActionCreators } from "../redux/actions";
import { getStore } from "../redux/store/configureStore";

export async function call(_method, _endpoint, _data) {
  try {
    let method = _.toString(_method).toLowerCase();
    let endpoint = _.toString(_endpoint);
    let data = _.clone(_data) || {};

    // // console.log('endpoint >>> ', endpoint);

    // NOTE: handle for GET method
    let resp = await axios[method](
      endpoint,
      method === "get" ? { params: data } : data
    );
    let respData = resp.data;
    let { status, errorCode, errorMessage, result } = respData;

    // // console.log(`respData >> `, respData);

    if (status <= 0) {
      console.error(`Service.call() Error :: ${errorCode} :: ${errorMessage}`);
      if (errorCode === -101) {
        if (window.location.pathname !== "/admin/login") {
          window.location = "/admin/login";
        }
      }
      let errorObj = {
        status,
        errorCode,
        errorMessage,
      };
      return errorObj;
    }

    if (result) {
      return result;
    }
    return respData;
  } catch (err) {
    console.error(err);
  }
  return null;
}

export async function callServer(_method, _endpoint, _data) {
  try {
    const API_SERVER = "https://farm-api.live4well.io";
    let method = _.toString(_method).toLowerCase();
    let endpoint = API_SERVER + _.toString(_endpoint);
    let data = _.clone(_data) || {};
    const reqObj = {
      method,
      url: endpoint,
    };

    let resp = await axios[method](
      endpoint,
      method === "get" ? { params: data } : data
    );
    let respData = resp.data;
    let { status, errorCode, errorMessage, result } = respData;
    if (status <= 0) {
      let errorObj = {
        status,
        errorCode,
        errorMessage,
      };
      return errorObj;
    }
    if (result) {
      return result;
    }
    return respData;
  } catch (err) {
    console.error(err);
  }
  return null;
}

export function createURL(action, endpoint, content) {
  let mContent = content || {};
  let url = "";
  url += endpoint;
  if (action.toLowerCase() === "get") {
    let queryStr = "";
    _.each(mContent, (val, key) => {
      queryStr += `${key}=${val}&`;
    });
    url += `?${queryStr}`;
  }
  return url;
}

export async function logout() {
  let result = await call("post", "/api/login/admin/logout");
  getStore().dispatch(ActionCreators.setAuth(false));
  getStore().dispatch(ActionCreators.setAdmin({}));
  return result;
}

export default call;
